import { render, staticRenderFns } from "./chinaMapEchart.vue?vue&type=template&id=700bb8e6&scoped=true&"
import script from "./chinaMapEchart.vue?vue&type=script&lang=js&"
export * from "./chinaMapEchart.vue?vue&type=script&lang=js&"
import style0 from "./chinaMapEchart.vue?vue&type=style&index=0&id=700bb8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700bb8e6",
  null
  
)

export default component.exports